import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { AppModules } from '@/types';
import { Paths, HeaderMenuOptionType } from '@/types/routes';
import {
  services,
  settingsServices,
} from '@/services/serviceRegistry';

/**
 * Convert ServiceDefinitions to HeaderMenuOptionType for backwards compatibility.
 * The header no longer shows these as tabs, but PageLayout still uses this structure
 * for sidebar resolution.
 */
const toHeaderMenu = (
  service: (typeof services)[number]
): HeaderMenuOptionType => ({
  icon: service.icon,
  label: service.name,
  sidebarMenus: service.sidebarMenus,
  module: service.id,
  path: service.basePath,
  adminOnly: service.adminOnly,
});

export const headerMenus: HeaderMenuOptionType[] = services.map(toHeaderMenu);

export const dropdownMenus: HeaderMenuOptionType[] = settingsServices.map(toHeaderMenu);

// Re-export teamsMenuItem for any existing consumers
export { teamsMenuItem } from '@/services/serviceRegistry';
